import { render, staticRenderFns } from "./BrQuestionItem.vue?vue&type=template&id=38a134b7&"
import script from "./BrQuestionItem.vue?vue&type=script&lang=js&"
export * from "./BrQuestionItem.vue?vue&type=script&lang=js&"
import style0 from "./BrQuestionItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports